import axiosHandler from '../axiosInterceptors';
import { FETCH_MEMBER_DATA, CREATE_MEMBER_DATA, UPDATE_MEMBER_DATA, DELETE_MEMBER_DATA,FETCH_MEMBER_GLOBAL_SEARCH_DATA, FETCH_USER_DROPDOWN_OPTION, NEW_MEMBER_MAIL } from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header
setAuthHeader();

export async function fetchMemberData(data) {
    try{
        const resp = await axiosHandler.get(FETCH_MEMBER_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function createMemberData(data) {
    try{
        const resp = await axiosHandler.post(CREATE_MEMBER_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function sendNewUserMail(data) {
    try{
        const resp = await axiosHandler.post(NEW_MEMBER_MAIL, data);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function updateMemberData(data) {
    try{
        const resp = await axiosHandler.patch(UPDATE_MEMBER_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function deleteMemberData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_MEMBER_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function fetchUserGlobalSearchData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_MEMBER_GLOBAL_SEARCH_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchUserDropdownOptionList() {
    try{
        const resp = await axiosHandler.get(FETCH_USER_DROPDOWN_OPTION);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}